module.exports = __webpack_public_path__ + "static/img/buddy_pictgrid20_920x821.042e5a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/buddy_pictgrid20_920x821.jpg
// module id = mSZ6
// module chunks = 0